export default () => ({
  providers: {},
  provider: null,
  filters: {
    attributes: [],
    countries: [],
    regions: [],
  },
});
